/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBbl: build.query<GetBblApiResponse, GetBblApiArg>({
      query: () => ({ url: `/bbl/bbl` }),
    }),
    getBblSummary: build.query<GetBblSummaryApiResponse, GetBblSummaryApiArg>({
      query: () => ({ url: `/bbl/bbl/summary` }),
    }),
    getBblSettings: build.query<
      GetBblSettingsApiResponse,
      GetBblSettingsApiArg
    >({
      query: () => ({ url: `/bbl/bbl/settings` }),
    }),
    getBblSettingsBblid: build.query<
      GetBblSettingsBblidApiResponse,
      GetBblSettingsBblidApiArg
    >({
      query: () => ({ url: `/bbl/bbl/settings/bblid` }),
    }),
    getBblApplications: build.query<
      GetBblApplicationsApiResponse,
      GetBblApplicationsApiArg
    >({
      query: () => ({ url: `/bbl/bbl/applications` }),
    }),
    getAll: build.query<GetAllApiResponse, GetAllApiArg>({
      query: (queryArg) => ({
        url: `/bbl/all`,
        params: {
          includeExternalBBLs: queryArg.includeExternalBbLs,
        },
      }),
    }),
    getBblFeaturetoggles: build.query<
      GetBblFeaturetogglesApiResponse,
      GetBblFeaturetogglesApiArg
    >({
      query: () => ({ url: `/bbl/bbl/featuretoggles` }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as bbl }
export type GetBblApiResponse = /** status 200 OK */ Bbl
export type GetBblApiArg = void
export type GetBblSummaryApiResponse = /** status 200 OK */ BblSummaryRead[]
export type GetBblSummaryApiArg = void
export type GetBblSettingsApiResponse = /** status 200 OK */ BblSettings
export type GetBblSettingsApiArg = void
export type GetBblSettingsBblidApiResponse = /** status 200 OK */ BblIdSettings
export type GetBblSettingsBblidApiArg = void
export type GetBblApplicationsApiResponse = /** status 200 OK */ BblSettings
export type GetBblApplicationsApiArg = void
export type GetAllApiResponse = /** status 200 OK */ BblSummaryRead[]
export type GetAllApiArg = {
  includeExternalBbLs?: boolean
}
export type GetBblFeaturetogglesApiResponse =
  /** status 200 OK */ FeatureToggle[]
export type GetBblFeaturetogglesApiArg = void
export type Bbl = {
  /** Name of the BBL(boligbyggerlag)
    <i>Navn</i> */
  name?: string | null
  /** Short name for the BBL
    <i>KortNavn</i> */
  shortName?: string | null
  /** Phone number for BBL
    <i>Telefon</i> */
  phone?: string | null
  /** Email for the BBL
    <i>Epost</i> */
  email?: string | null
  /** Company number/ organization number of the BBL
    <i>Organisasjonsnummer</i> */
  companyNumber?: string | null
  /** Client number of the BBL
    <i>KlientNr</i> */
  clientNr?: number
  /** External parter number of the bbl
    <i>EksternPartnerNr</i> */
  externalPartnerNr?: string | null
  /** Business address of the BBL
    <i>Forretningsadresse</i> */
  businessAddress?: string | null
  /** Branding code for the  bbl */
  brandingCode?: string | null
  /** Invoice convention activation date
   *Fakturaprinsipp dato* */
  invoiceConventionDate?: string | null
}
export type ProblemDetails = {
  type?: string | null
  title?: string | null
  status?: number | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}
export type BblSummary = {
  /** BblCode (unique id) */
  bblCode?: string | null
  /** Name of the BBL(boligbyggerlag) */
  name?: string | null
  /** Short Name of the BBL(boligbyggerlag) <i>Kortnavn</i> */
  shortName?: string | null
  /** Name of the BBL(boligbyggerlag) */
  url?: string | null
  /** Url to web application used to become a member ("Bli Medlem") */
  becomeAMemberUrl?: string | null
  /** If preemption enabled for this BBL */
  hasPreemption?: boolean
  /** BBL unique numeric reference */
  bblExternalNumber?: string | null
  /** Branding code for styling */
  brandingCode?: string | null
  /** BBL Partnercode */
  bblPartnerCode?: string | null
  memberBenefitsType?: MemberBenefitsType
  schedulingPolicy?: ScheduledJobPolicy
  /** Indicates if this bbl has enabled option for online payment of membership fees */
  membershipFeePaymentEnabled?: boolean
  membershipHandling?: BblMembershipHandling
  /** Indicates if the BBL wants to enable 2 factor authentication (sms/email code) */
  enableMFA?: boolean
  /** Tells what gateway client should be used when vipps is enabled. When null vipps is not enabled */
  enableVipps?: boolean
  /** Minimum recaptcha score used to avoid bots */
  minimumRecaptchaScore?: number
  /** True if carbon accounting is enabled for this BBL. Otherwise false. */
  hasCarbonAccounting?: boolean
  /** True if this BBL has access to reskontro. */
  hasResKontro?: boolean
  /** Uses external invoice system for claims
   *Bruker eksternt økonomisystem som ikke snakker med Hårfagre* */
  hasExternalInvoiceSystem?: boolean
  /** True if BBL is NOT a customer of BBL Pivotal
   *F.eks. BOB* */
  isExternalBBL?: boolean
  /** External preemption url
   *Brukes til å vise url for forkjøpsrett for boligbyggelag som ikke er kunder hos oss, men som samarbeider med våre kunder angående forkjøpsrett på tvers av boligbyggelagene. Skal ha verdi hvis IsExternalBBL = true* */
  externalPreemptionUrl?: string | null
  /** true if the BBL has enabled the option to add/remove co-owner from "Min side" and HF_Parameter 'FjernLeggTilMedeierVaregruppe' and 'FjernLeggTilMedeierMinSide' are set. */
  canChangeCoOwnerFromMyPage?: boolean
  /** True if the BBL has EHF invoice import enabled. This is true for all production BBL's, but may be false for development/test BBLs. */
  hasEhf?: boolean
}
export type BblSummaryRead = {
  /** BblCode (unique id) */
  bblCode?: string | null
  /** Name of the BBL(boligbyggerlag) */
  name?: string | null
  /** Short Name of the BBL(boligbyggerlag) <i>Kortnavn</i> */
  shortName?: string | null
  /** Name of the BBL(boligbyggerlag) */
  url?: string | null
  /** Url to web application used to become a member ("Bli Medlem") */
  becomeAMemberUrl?: string | null
  /** If preemption enabled for this BBL */
  hasPreemption?: boolean
  /** BBL unique numeric reference */
  bblExternalNumber?: string | null
  /** Branding code for styling */
  brandingCode?: string | null
  /** BBL Partnercode */
  bblPartnerCode?: string | null
  memberBenefitsType?: MemberBenefitsType
  schedulingPolicy?: ScheduledJobPolicy
  /** Indicates whether this BBL uses the member benefits program. */
  hasMemberBenefits?: boolean
  /** Indicates if this bbl has enabled option for online payment of membership fees */
  membershipFeePaymentEnabled?: boolean
  membershipHandling?: BblMembershipHandling
  /** Indicates if the BBL wants to enable 2 factor authentication (sms/email code) */
  enableMFA?: boolean
  /** Tells what gateway client should be used when vipps is enabled. When null vipps is not enabled */
  enableVipps?: boolean
  /** Minimum recaptcha score used to avoid bots */
  minimumRecaptchaScore?: number
  /** True if carbon accounting is enabled for this BBL. Otherwise false. */
  hasCarbonAccounting?: boolean
  /** True if this BBL has access to reskontro. */
  hasResKontro?: boolean
  /** Uses external invoice system for claims
   *Bruker eksternt økonomisystem som ikke snakker med Hårfagre* */
  hasExternalInvoiceSystem?: boolean
  /** Has parner code in hf db but no bonus integration
   *Brukes for å skjule menypunkt Bonus samt deler av gui for enkelte boligbyggelag* */
  hasPartnerCodeButNoBonusIntegration?: boolean
  /** True if BBL is NOT a customer of BBL Pivotal
   *F.eks. BOB* */
  isExternalBBL?: boolean
  /** External preemption url
   *Brukes til å vise url for forkjøpsrett for boligbyggelag som ikke er kunder hos oss, men som samarbeider med våre kunder angående forkjøpsrett på tvers av boligbyggelagene. Skal ha verdi hvis IsExternalBBL = true* */
  externalPreemptionUrl?: string | null
  /** true if the BBL has enabled the option to add/remove co-owner from "Min side" and HF_Parameter 'FjernLeggTilMedeierVaregruppe' and 'FjernLeggTilMedeierMinSide' are set. */
  canChangeCoOwnerFromMyPage?: boolean
  /** True if the BBL has EHF invoice import enabled. This is true for all production BBL's, but may be false for development/test BBLs. */
  hasEhf?: boolean
}
export type Urls = {
  /** Root url to "mypage" */
  myPage?: string | null
  /** Root url to old "mypage" */
  oldMyPage?: string | null
  /** Url for clients using Klare Finans' infocenter (previously BBL Finans). The link appears on my page for affiliate customers. */
  financeInfocenter?: string | null
  /** Url to a digital course for residents (beboerskolen). */
  digitalCourseForResidents?: string | null
  /** Url to  BBL homepage for transfer of membership */
  membershipTransfer?: string | null
  /** URL For page showing Housing Cooperatives new housing projets.
    <remark>Angi url til siden for visning av boligbyggelagets nybolig prosjekter.</remark> */
  newHousingProjects?: string | null
  /** Url for nextgent portal */
  newPortal?: string | null
  /** Url for old portal */
  oldPortal?: string | null
  /** Url for styreskolen */
  digitalCourseForBoard?: string | null
  /** Url for Bevar HMS */
  bevarHms?: string | null
  /** Url for Bevar vedlikehold */
  bevarVedlikehold?: string | null
  /** Url til boligbyggelagets HMS-system */
  hmsSystem?: string | null
  /** Url til Plussplan */
  plussplan?: string | null
  /** Url til boligbyggelagets vedlikeholdssystem */
  vedlikeholdSystem?: string | null
  /** Url for NBBL jusprat */
  digitalCourseLegalTalk?: string | null
  /** Url for BBL egne kurs */
  bblEgneKurs?: string | null
  /** Url for BBL egne veiledninger */
  bblEgneVeiledninger?: string | null
  /** Url til IF bygningssjekk for BBL som ønsker å tilby denne tjenesten */
  forsikringsAvtale?: string | null
  /** URL forsikring - Info om skadedyravtalen */
  skadedyravtalen?: string | null
  /** URL forsikring - Info om Advokatforsikring */
  advokatforsikring?: string | null
  /** URL forsikring - Info om Bygningssjekken */
  bygningssjekken?: string | null
  /** URL forsikring - Håndbok om vedlikehold og skadevern */
  vedlikeholdSkadevern?: string | null
  /** URL forsikring - Håndbok om vedlikehold og skadevern - Min Side */
  vedlikeholdSkadevernMinSide?: string | null
}
export type Notifications = {
  /** Allow bulletins to be sent as email BBLD.Microservice.BBL.Models.Enums.BblParameters.OppslagsTavleEpost */
  allowBulletinEmails?: boolean
  /** Allow documents to be sent as email BBLD.Microservice.BBL.Models.Enums.BblParameters.DokumentEpost */
  allowDocumentEmails?: boolean
  /** Allow publications to be sent as email BBLD.Microservice.BBL.Models.Enums.BblParameters.PubliseringEpost */
  allowPublicationEmails?: boolean
}
export type PerBblFeature = {
  /** If bbl has enabled online payment of due membership fees */
  membershipFeePayment?: boolean
  /** If bbl has enabled member benefits */
  memberBenefits?: boolean
}
export type CarbonAccounting = {
  /** True if the carbon accounting feature is enabled (toggled on) for this BBL. Otherwise false. */
  hasCarbonAccounting?: boolean
  /** Price per month for clients ordering portal access to consumption-based carbon accounting.
    Use microservice-client/{clientId}/settings to check if "baerekraft" and "karbonregnskap" are enabled for the client.
    <remarks>Pris pr måned for en forvaltningsklient som bestiller forbruksbasert karbonregnskap</remarks> */
  pricePerMonthForConsumptionBasedCarbonAccounting?: number | null
  /** Varegruppe er satt */
  isConfigured?: boolean
}
export type BliMedlemSettings = {
  /** Download link for member benefit android app url */
  fordelskortAndroidAppUrl?: string | null
  /** Download link for member benefit app ios app url */
  fordelskortIosAppUrl?: string | null
  /** Google tag manager id for bli medlem */
  bliMedlemGoogleTagManagerId?: string | null
  /** Option for enabling future payer of membership */
  showFuturePayerOption?: boolean
  /** If allows only digital membership card */
  tillatKunDigitaltMedlemskort?: boolean
  /** If allows giftmembership without gift package */
  gavemedlemskapUtenGavepakke?: boolean
  /** Display name for MyPage */
  visningsnavnForEgenMinSide?: string | null
}
export type PortalDisplayNames = {
  /** Portal display name. I.e. "Bonabo Styret" */
  portalDisplayName?: string | null
  /** Portal display name short. I.e. "Styret" */
  portalDisplayNameShort?: string | null
  /** My Page display name. I.e. "Bonabo Min side" */
  myPageDisplayName?: string | null
  /** My Page display name short. I.e. "Min side" */
  myPageDisplayNameShort?: string | null
}
export type BblSettings = {
  /** Phone for questions related to portal/minside */
  phoneNumberForPortalQuestions?: string | null
  /** Email for questions related to portal/minside */
  emailForPortalQuestions?: string | null
  /** Phone for general questions */
  phoneNumberForGeneralQuestions?: string | null
  /** Email for general questions */
  emailForGeneralQuestions?: string | null
  /** URL/Adresse til nettside med informasjon om forkjøpsrett i boligbyggelaget */
  preemptionInformationUrl?: string | null
  /** URL/Adresse til nettside med informasjon om felles forkjøpsrett */
  commonPreemptionInformationUrl?: string | null
  /** Url to web application used to become a member ("Bli Medlem") */
  becomeAMemberUrl?: string | null
  /** Url to custom privacy statement ("personvernerklæring") */
  customPrivacyStatementUrl?: string | null
  /** Url for redirect after logout from Min side and Forkjøp */
  afterLogoutRedirectUrl?: string | null
  /** Google Tag Manager Id */
  gtmId?: string | null
  /** Minside Google Tag Manager Id */
  minsideGtmId?: string | null
  /** URL to BBL home page from HF parameter */
  bblUrl?: string | null
  /** Email for Invoice reception */
  emailInvoiceReception?: string | null
  /** Post address for invoices. */
  invoiceAddressPost?: boolean
  /** Post address for business */
  businessAddressPost?: boolean
  /** True/false for if it is allowed to change approver for invoice approval */
  invoiceApprovalAllowChangeApprover?: boolean
  /** Url with info about terms of membership */
  termsOfMembershipUrl?: string | null
  /** True if the house-building cooperative publishes a membership magazine */
  hasPrintedMembershipMagazine?: boolean
  /** Url to a digital membership magazine, typically located on the house-building cooperation's website */
  digitalMembershipMagazineUrl?: string | null
  /** Url with info about membership benefits */
  membershipBenefitsUrl?: string | null
  /** Indicates whether it is permitted to transfer a membership through self-service (like Min Side) */
  allowsSelfServiceTransferOfMembership?: boolean
  /** Indicates whether an alternative payer can be chosen for future membership fees when buying a gift membership online (for instance in Bli medlem) */
  allowsGiftMembershipBuyerToPayFutureMembershipFees?: boolean
  urls?: Urls
  notifications?: Notifications
  /** Email for notifications of new member transfer to BBL */
  memberTransferNotificationEmail?: string | null
  features?: PerBblFeature
  /** The minimum amount available for a member in order to trigger payout of bonus when membership is canceled or transfered */
  minimumMemberBonusForPayout?: number | null
  /** True indicates that membership seniority can exceed the age of the member. Affects membership transfer if the membership is older than the receiving person. */
  allowsMembershipSeniorityBeyondMemberAge?: boolean
  /** Indicates if the BBL wants to enable 2 factor authentication (sms/email code) */
  enableMFA?: boolean
  /** Minimum recaptcha score used to avoid bots */
  minimumRecaptchaScore?: number
  /** Tells what gateway client should be used when vipps is enabled. When null vipps is not enabled */
  enableVipps?: boolean
  /** Minimum date of damage for insurance cases shown in the portal, if defined. Otherwise null. */
  insuranceCasesMinimumDateOfDamage?: string | null
  carbonAccounting?: CarbonAccounting
  /** If documenttype is set the meetingprotocol can be showed to "Forretningsfører" */
  isShareBoardMeetingProtocolConfigured?: boolean
  /** e-mail to be used for communication with the insurance company in "totalforsikring" */
  emailInsurance?: string | null
  /** True if BBL Pivotal is allowed to login in portal for all clients to perform support. Otherwise false. */
  isTechnicalSupportEnabled?: boolean
  bliMedlemSettings?: BliMedlemSettings
  displayNames?: PortalDisplayNames
  /** True if this BBL has access to reskontro. */
  hasResKontro?: boolean
  /** Uses external invoice system for claims
   *Bruker eksternt økonomisystem som ikke snakker med Hårfagre* */
  hasExternalInvoiceSystem?: boolean
  /** Has partner code in hf db but no bonus integration
   *Brukes for å skjule menypunkt Bonus samt deler av gui for enkelte boligbyggelag* */
  hasPartnerCodeButNoBonusIntegration?: boolean
  /** Budget from old portal was implemented anew i 2024.
    House-building cooperations could opt to stick with the old implementation.
    True if opted to stick with budget implementation in old portal, otherwise false. */
  isLateAdopterOfNewPortalBudget?: boolean
  /** true if the BBL has enabled the option for online cancellation membership from "Min side" */
  allowsSelfServiceMembershipCancellation?: boolean
  /** true if the BBL has enabled the option for online membership exchange from "Min side" */
  allowsSelfServiceMembershipExchange?: boolean
  /** true if the BBL has enabled the option to add/remove co-owner from "Min side" and HF_Parameter 'FjernLeggTilMedeierVaregruppe' and 'FjernLeggTilMedeierMinSide' are set. */
  canChangeCoOwnerFromMyPage?: boolean
  /** Reimbursement max amonut */
  reimbursementMaxAmount?: number | null
  /** Delayed payment days from financing institution (Antall dager Forsinket utbetaling fra finansieringsforetak) - Table: BBL.FORSINKET_UTBETALING_FINANSIERING */
  delayedPaymentDaysFromFinancingInstitution?: number | null
  /** Voting is enabled for bulletin board */
  isVotingEnabledForBulletinBoard?: boolean
  /** True if clicking the house-building cooperation's logo in Portal navigates to the landing page for switching between applications. False if clicking the logo navigates to the Portal home page. */
  navigateToLandingPageWhenBblLogoClickedInPortal?: boolean
  /** True if clicking the house-building cooperation's logo in My Page navigates to the landing page for switching between applications. False if clicking the logo navigates to the My Page home page. */
  navigateToLandingPageWhenBblLogoClickedInMyPage?: boolean
  /** True if contact persons at the house-building cooperation is shown in Portal */
  showBblContactPersonsInPortal?: boolean
}
export type BblIdSettings = {
  /** Used by bbl for reviving emails */
  operationsEmailAddress?: string | null
  /** Email for questions regarding the portal */
  portalEmailAddress?: string | null
  /** Phone number for questions regarding the portal */
  portalPhone?: string | null
  /** Enable or disable MFA (Multi-Factor Authentication) */
  enableMFA?: boolean
  /** Enable or disable Vipps as a login method */
  enableVipps?: boolean
  /** Minimum recaptcha score used to avoid bots */
  minimumRecaptchaScore?: number
}
export type FeatureToggle = {
  id?: string | null
  enabled?: boolean
}
export enum MemberBenefitsType {
  None = 'None',
  Full = 'Full',
  Marketing = 'Marketing',
}
export enum ScheduledJobPolicy {
  Disabled = 'Disabled',
  Full = 'Full',
  ServiceDependant = 'ServiceDependant',
}
export enum BblMembershipHandling {
  Standard = 'Standard',
  External = 'External',
  ExternalWithMembershipHandling = 'ExternalWithMembershipHandling',
}
export const {
  useGetBblQuery,
  useGetBblSummaryQuery,
  useGetBblSettingsQuery,
  useGetBblSettingsBblidQuery,
  useGetBblApplicationsQuery,
  useGetAllQuery,
  useGetBblFeaturetogglesQuery,
} = injectedRtkApi
